import { render, staticRenderFns } from "./MexServicios.vue?vue&type=template&id=5bb414df"
import script from "./MexServicios.vue?vue&type=script&lang=js"
export * from "./MexServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports